module.exports = __webpack_public_path__ + "media/images/flags/1x1/kor-da9d8bd912e282b0e11eb1af1bc42fc7.svg";